// @flow
import React from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import ticketReservationSelectors from "../../selectors/ticketReservationSelectors";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";

function TicketReservationSoldOut() {
  const history = useHistory();
  return (
    <Box mt={6} mb={2}>
      <Typography variant="h4" component="h1" align="center">
        <b>Dieses Spiel ist leider ausverkauft.</b>
      </Typography>
      <Box mt={2}>
        <Typography align="center" color="textSecondary">
          Aufgrund der Hygiene-Schutzmaßnahmen während der Corona-Pandemie
          können wir nur eine begrenzte Zahl an Plätzen vergeben. Wir bitten um
          dein Verständnis.
        </Typography>
      </Box>
      <Box mt={2} mb={2}>
        <Typography align="center" color="textSecondary">
          <b>Tipp:</b> Die Reservierung wird immer{" "}
          {ticketReservationSelectors.registrationDaysOpening} Tage vor
          Spielbeginn freigeschaltet.
        </Typography>
      </Box>
      <Typography align="center">
        <Button onClick={() => history.push({ pathname: "/" })} color="primary">
          Zum Spielplan
        </Button>
      </Typography>
    </Box>
  );
}

export default TicketReservationSoldOut;
